// routes/AiToolsRoutes.jsx
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import BioBuilder from './BioBuilder';
import AiToolsLanding from './AiLanding';
import WorkplanBuilder from './WorkplanBuilder';
import RagAssistant from './RagAssistant';
import VectorStores from './Vectors';

// import BioBuilder from '../views/BioBuilder';
// import WorkplanBuilder from '../views/WorkplanBuilder';
// import ApproachBuilder from '../views/ApproachBuilder';
// import WritingAssistant from '../views/WritingAssistant';

const AiToolsRoutes = ({ match }) => {
  const { path } = match;

  return (
    <Switch>
      <Route exact path={path} component={AiToolsLanding} />
      <Route path={`${path}/bio-builder`} component={BioBuilder} />
      <Route path={`${path}/workplan-builder`} component={WorkplanBuilder} />
      <Route path={`${path}/rag-assistant/:id`} component={RagAssistant} />
      <Route path={`${path}/vector-stores`} component={VectorStores} />
      {/* <Route path={`${path}/approach-builder`} component={ApproachBuilder} /> */}
      {/* <Route path={`${path}/writing-assistant`} component={WritingAssistant} /> */}
    </Switch>
  );
};

export default AiToolsRoutes;
